import React, { useEffect, useState, useRef } from 'react'
import { Grid, Panel, Row, Col, Input, Button } from 'rsuite'
import GoogleMapReact from 'google-map-react'
import Marker from './Marker'
import SearchBox from './SearchBox'
import ReactDOM from 'react-dom'
import { fitBounds } from 'google-map-react'

export default function GMap(props) {
  const {
    onSelectPlace,
    markers,
    placeholder,
    singleLat,
    singleLng,
    locationName,
    hideSearchBox,
    defaultCenter,
    defaultZoom,
  } = props
  const [center, setCenter] = useState({ lat: 13.7749, lng: 100.5197 })
  const [zoom, setZoom] = useState(12)
  const [mapsApiLoaded, setMapsApiLoaded] = useState(false)
  const [mapMarkers, setMapMarkers] = useState([{ lat: 0.000000, lng: 0.000000 }])

  const [selectedLat, setSelectedLat] = useState(13.7749)
  const [selectedLng, setSelectedLng] = useState(100.5197)

  const mapRef = useRef(null)
  const mapsRef = useRef(null)
  const searchRef = useRef(null)

  // console.log('markers', markers)

  useEffect(() => {
    console.log('useEffect markers', markers)
    if (markers.length > 0) {
      console.log('set markers')
      setMapMarkers(markers)
      setCenter({ lat: 13.7749, lng: 100.5197 })
      setZoom(12)
    }else{
      setMapMarkers([{ lat: 0.000000, lng: 0.000000 }])
    }
  }, [markers])

  useEffect(() => {
    console.log('set single point',singleLat,singleLng)
    if (singleLat && singleLng) {
      setSelectedLat(singleLat)
      setSelectedLng(singleLng)
      setCenter({ lat: singleLat, lng: singleLng })
    } else {
      setSelectedLat(0.000000)
      setSelectedLng(0.000000)
    }
  }, [singleLat, singleLng])

  const apiLoaded = (map, maps) => {
    const input = ReactDOM.findDOMNode(searchRef.current)
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

    mapsRef.current = maps

    setMapsApiLoaded(true)
  }

  const onPlacesChanged = (places) => {
    console.log('places', places)

    if (places.length == 0) {
      return
    }
    places.forEach((place) => {
      if (!place.geometry || !place.geometry.location) {
        console.log('Returned place contains no geometry')
        return
      }
      let lat = place.geometry.location.lat()
      let lng = place.geometry.location.lng()
      setSelectedLat(lat)
      setSelectedLng(lng)

      setCenter({ lat: lat, lng: lng })

      onSelectPlace({ lat: lat, lng: lng, name: place.name })
    })
  }

  const ganerateMarker = mapMarkers.map((item, index) => {
    console.log(item)
    return <Marker key={index} lat={item.lat} lng={item.lng} text="My Marker" color="#0099ff" />
  })

  return (
    <Grid>
      <Row>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
        <Col lg={20} md={20} sm={20} xs={20}>
          <div style={{ height: '50vh', width: '100%' }}>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: 'AIzaSyBqFidYzANyXs80bpDtVei16oPJy_HvVsI',
                libraries: ['places'],
              }}
              defaultCenter={defaultCenter || center}
              center={center}
              defaultZoom={defaultZoom || zoom}
              style={{}}
              onGoogleApiLoaded={({ map, maps, ref }) => {
                console.log('ref', ref)
                mapRef.current = ref
                apiLoaded(map, maps)
              }}
            >
              <Marker
                lat={selectedLat}
                lng={selectedLng}
                text="My Marker"
                color="#DB4437"
                zIndex={1}
              />
              
              {console.log('props.markers',props.markers)}
              {ganerateMarker}

              <div ref={searchRef} style={{ width: '100%' }}>
                {mapsApiLoaded && !hideSearchBox && (
                  <SearchBox
                    placeholder={placeholder || 'ค้นหาสถานที่'}
                    onPlacesChanged={onPlacesChanged}
                    style={{ width: '90%', marginTop: '1%', marginLeft: '1%' }}
                    locationName={locationName}
                  />
                )}
              </div>
            </GoogleMapReact>
          </div>
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
    </Grid>
  )
}
